import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicItemBaseComponent } from '@ups/xplat/dynamic-render';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ups-dynamic-circle',
  styleUrls: ['dynamic-circle.component.scss'],
  template: `
    <div class="dynamic-field drawing-circle" [formGroup]="group">
      <div [innerHTML]="config?.value"></div>
    </div>
  `,
  standalone: false,
})
export class DynamicCircleComponent extends DynamicItemBaseComponent {}
